// Türkiye il listesi (plaka kodu + ad).
// Kodlar, web sitesindeki harita SVG'sindeki il id'leriyle BİREBİR aynıdır.
// Otomatik üretildi — elle düzenlemeyin.

const TURKEY_PROVINCES = [
  { code: "TR01", name: "Adana" },
  { code: "TR02", name: "Adiyaman" },
  { code: "TR03", name: "Afyonkarahisar" },
  { code: "TR04", name: "Agri" },
  { code: "TR05", name: "Amasya" },
  { code: "TR06", name: "Ankara" },
  { code: "TR07", name: "Antalya" },
  { code: "TR08", name: "Artvin" },
  { code: "TR09", name: "Aydin" },
  { code: "TR10", name: "Balikesir" },
  { code: "TR11", name: "Bilecik" },
  { code: "TR12", name: "Bingöl" },
  { code: "TR13", name: "Bitlis" },
  { code: "TR14", name: "Bolu" },
  { code: "TR15", name: "Burdur" },
  { code: "TR16", name: "Bursa" },
  { code: "TR17", name: "Çanakkale" },
  { code: "TR18", name: "Çankiri" },
  { code: "TR19", name: "Çorum" },
  { code: "TR20", name: "Denizli" },
  { code: "TR21", name: "Diyarbakir" },
  { code: "TR22", name: "Edirne" },
  { code: "TR23", name: "Elazig" },
  { code: "TR24", name: "Erzincan" },
  { code: "TR25", name: "Erzurum" },
  { code: "TR26", name: "Eskişehir" },
  { code: "TR27", name: "Gaziantep" },
  { code: "TR28", name: "Giresun" },
  { code: "TR29", name: "Gümüşhane" },
  { code: "TR30", name: "Hakkari" },
  { code: "TR31", name: "Hatay" },
  { code: "TR32", name: "Isparta" },
  { code: "TR33", name: "Mersin" },
  { code: "TR34", name: "Istanbul" },
  { code: "TR35", name: "Izmir" },
  { code: "TR36", name: "Kars" },
  { code: "TR37", name: "Kastamonu" },
  { code: "TR38", name: "Kayseri" },
  { code: "TR39", name: "Kirklareli" },
  { code: "TR40", name: "Kırşehir" },
  { code: "TR41", name: "Kocaeli" },
  { code: "TR42", name: "Konya" },
  { code: "TR43", name: "Kütahya" },
  { code: "TR44", name: "Malatya" },
  { code: "TR45", name: "Manisa" },
  { code: "TR46", name: "K. Maras" },
  { code: "TR47", name: "Mardin" },
  { code: "TR48", name: "Mugla" },
  { code: "TR49", name: "Mus" },
  { code: "TR50", name: "Nevşehir" },
  { code: "TR51", name: "Niğde" },
  { code: "TR52", name: "Ordu" },
  { code: "TR53", name: "Rize" },
  { code: "TR54", name: "Sakarya" },
  { code: "TR55", name: "Samsun" },
  { code: "TR56", name: "Siirt" },
  { code: "TR57", name: "Sinop" },
  { code: "TR58", name: "Sivas" },
  { code: "TR59", name: "Tekirdag" },
  { code: "TR60", name: "Tokat" },
  { code: "TR61", name: "Trabzon" },
  { code: "TR62", name: "Tunceli" },
  { code: "TR63", name: "Sanliurfa" },
  { code: "TR64", name: "Usak" },
  { code: "TR65", name: "Van" },
  { code: "TR66", name: "Yozgat" },
  { code: "TR67", name: "Zinguldak" },
  { code: "TR68", name: "Aksaray" },
  { code: "TR69", name: "Bayburt" },
  { code: "TR70", name: "Karaman" },
  { code: "TR71", name: "Kinkkale" },
  { code: "TR72", name: "Batman" },
  { code: "TR73", name: "Sirnak" },
  { code: "TR74", name: "Bartın" },
  { code: "TR75", name: "Ardahan" },
  { code: "TR76", name: "Iğdir" },
  { code: "TR77", name: "Yalova" },
  { code: "TR78", name: "Karabük" },
  { code: "TR79", name: "Kilis" },
  { code: "TR80", name: "Osmaniye" },
  { code: "TR81", name: "Düzce" },
];

export default TURKEY_PROVINCES;
